module.exports = __webpack_public_path__ + "static/media/ico_pdf.a88e5f86.svg";